import { render, staticRenderFns } from "./CollectedReference.vue?vue&type=template&id=c56b7418&scoped=true&"
import script from "./CollectedReference.vue?vue&type=script&setup=true&lang=js&"
export * from "./CollectedReference.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./CollectedReference.vue?vue&type=style&index=0&id=c56b7418&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c56b7418",
  null
  
)

export default component.exports